import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`

  padding: 16px; // padding around the grid
`;

export const AppCard = styled.div`
  width: 100%;
  height: 100%;

  background-color: ${props => props.theme.colors.card_300};
  border-radius: 10px;
  padding: 20px;

  display: flex;
  flex-direction: column;

  justify-content: space-between;

  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;

  margin-bottom: 10px;
`;

export const Title = styled.span`
  font-weight: 700;
  font-size: 18px;
`;

export const Content = styled.span`
  
`;


export const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
  width: 100%;
  height: 100%;
`;